<ng-container *ngIf="!question.isReadOnlyRenderDiv()">
  <ng-template [component]="{ name: 'sv-text-area', data: { model: question.commentTextAreaModel } }"></ng-template>
</ng-container>
<div *ngIf="question.isReadOnlyRenderDiv()">{{ question.comment }}</div>
